<script lang="ts">
  import Hero4Form from './Hero4Form.svelte';
  import { BulletPoint } from '../../components/index';
  import './css/hero4.scss';
  import type { Hero3 } from '../types';
  import type { MktSettings } from 'customer-components/lib/types';
  import PricingTag from './_PricingTag.svelte';

  export let properties: Hero3;
  export let settings: MktSettings;

  $: ({
    callouts,
    headline,
    subHeadline,
    description,
    image,
    items,
    currentStep,
    badges,
    googleBadge,
    caption,
    pricingTag,
  } = properties);
  if (typeof currentStep != 'number') currentStep = 1;
  $: ({ numberOfReviews, phoneNumber } = settings);
</script>

<section class="hero5">
  <div class="hero-img">
    {#if googleBadge}
      <a href="#testimonials-section" class="google-reviews-box">
        <p>{numberOfReviews} Reviews</p>
        <div class="devider" />
        <img
          src="https://voolt-template-asset.b-cdn.net/u-15477/w-6345/cHdTvqruSUi8ARQeRJVzLg_google-logo.png"
          alt="Google logo"
          class="google-logo"
          loading="lazy"
        />
      </a>
    {/if}
    <img src={image?.value} alt="hero-img" />
    <div class="hero-badges">
      {#each badges as badge}
        <div class="badge">
          <img src={badge} alt="badge-img" />
        </div>
      {/each}
    </div>
  </div>
  <div class="wrapper">
    <div class="hero-content">
      <div class="hero-title">
        {#if pricingTag?.content?.active}
          <PricingTag {pricingTag} />
        {/if}
        <h1 class="h1">{@html headline.value}</h1>
        <h2 class="h2">{@html subHeadline.value}</h2>
        <p class="sub-text">{@html description.value}</p>
      </div>
      <Hero4Form
        step={currentStep}
        bind:phoneNumber
        bind:steps={items}
        bind:properties
      />
      <div class="benefits-list">
        {#each callouts.value as text}
          <div class="benefit">
            <BulletPoint bulletIcon={callouts.icon} />
            <p class="text">
              {@html text}
            </p>
          </div>
        {/each}
      </div>
      <div class="hero-bottom">
        {#if caption?.value}
          <a
            class="hero-stars-and-reviews"
            href="#testimonial"
            style="text-decoration:none;"
          >
            <p>{@html caption.value}</p>
          </a>
        {/if}
      </div>
    </div>
  </div>
</section>
